import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import Toast from '../atoms/Toast';
import { useToastManager } from '../../utils/toastManager';
import '../../styles/organisms/toast-container.css';

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast, registerListener } = useToastManager();

  useEffect(() => {
    const cleanup = registerListener();
    return cleanup;
  }, [registerListener]);

  return createPortal(
    <div 
      className="toast-container"
      style={{
        position: 'fixed',
        top: '20px',
        right: '20px',
        bottom: 'auto',
        left: 'auto',
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        pointerEvents: 'none',
      }}
    >
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          onClose={() => removeToast(toast.id)}
          duration={5000}
        />
      ))}
    </div>,
    document.body
  );
};

